// extracted by mini-css-extract-plugin
export default {"wrapper":"hdoGydHcGNLwcn1Pi1lP","settingsGeneral":"xztrZHu4IWbNka9aD9LN"};